import { render, staticRenderFns } from "./priceUpdateItemDialog.vue?vue&type=template&id=67fe8693&"
import script from "./priceUpdateItemDialog.vue?vue&type=script&lang=js&"
export * from "./priceUpdateItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports